import script from "./InputWithSuggestions.vue?vue&type=script&setup=true&lang=js"
export * from "./InputWithSuggestions.vue?vue&type=script&setup=true&lang=js"

import "./InputWithSuggestions.vue?vue&type=style&index=0&id=6018cddf&scoped=true&lang=scss"

import exportComponent from "D:\\vsts-agent\\_work\\42\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6018cddf"]])

export default __exports__